import { useNavigate } from 'react-router-dom'
import useNavigationStore from '@/context/useNavigationStore'

const useCallRouteWithDirection = () => {
  const navigate = useNavigate()
  const { setBackNav, setActiveSection, pushHistory } = useNavigationStore()

  const callRouteWithDirection = (
    route: string,
    back: boolean,
    tabIndex: number,
    replace = false,
  ) => {
    navigate(route, { replace })
    setBackNav(back)
    setActiveSection(tabIndex)
    pushHistory(route)
  }

  return callRouteWithDirection
}

export default useCallRouteWithDirection
